import axiosBase from "axios";
import { BASE_URL,CREATE_EMPLOYEE,EMPLOYEE, IMPORT_EMPLOYEES, TEMPLATE_SHEET, UPDATE_EMPLOYEES  } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
 
export async function getEmployees(params: string = "") {
  const response = await axios.get(BASE_URL + EMPLOYEE +'/Get'+ params);
  return response.data;
}

export async function getRegistrationLink(params: string = "") {
  const response = await axios.get(BASE_URL + EMPLOYEE +'/GetEmployeeRegistrationURL'+ params);
  return response.data;
}

export async function getTemplateSheet(params: string = "") {
  const response = await axios.get(BASE_URL + TEMPLATE_SHEET + params);
  return response.data;
}

export async function addEmployee(data: FormData) {
  const response = await axios.post(BASE_URL + EMPLOYEE, data);
  return response.data;
}

export async function createUser(params: string = "",data: FormData) {
  const response = await axiosBase.post(BASE_URL + CREATE_EMPLOYEE+params, data,
    {
      headers: {
        Authorization: `Basic YWRtaW51c2VyOnNlY3JldHBhc3M=`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export async function editEmployee(data: FormData, id: string) {
  const response = await axios.patch(BASE_URL + EMPLOYEE + "/" + id, data);
  return response.data;
}

export async function deleteEmployee(id: string) {
  const response = await axios.delete(BASE_URL + EMPLOYEE + "/" + id);
  return response.data;
}

export async function importEmployee(data: FormData) {
  const response = await axios.post(BASE_URL + IMPORT_EMPLOYEES  , data);
  return response.data;
}

export async function updateEmployee(data: any[]) {
  const response = await axios.post(BASE_URL + UPDATE_EMPLOYEES  , data);
  return response.data;
}

export const EmployeeCells: HeadCell[] = [
  {
    id: "ProfilePicture",
    numeric: false,
    disablePadding: false,
    label: "T_Logo",
  },
  {
    id: "firstName",
    numeric: false,
    disablePadding: false,
    label: "T_first_name",
  },
  {
    id: "middleName",
    numeric: false,
    disablePadding: false,
    label: "T_middle_name",
  },
  {
    id: "lastName",
    numeric: false,
    disablePadding: false,
    label: "T_last_name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "T_email",
  },
  {
    id: "phoneNumber",
    numeric: false,
    disablePadding: false,
    label: "T_phone_number",
  },
  {
    id: "employeeId",
    numeric: false,
    disablePadding: false,
    label: "T_employee_id",
  },
  {
    id: "job",
    numeric: false,
    disablePadding: false,
    label: "T_job",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
export const EmployeeCellsExport= ['firstName','middleName','lastName','email','job']

export const UpdateEmployeeCells: HeadCell[] = [
  {
    id: "FirstName",
    numeric: false,
    disablePadding: false,
    label: "T_first_name",
  },
  {
    id: "MiddleName",
    numeric: false,
    disablePadding: false,
    label: "T_middle_name",
  },
  {
    id: "LastName",
    numeric: false,
    disablePadding: false,
    label: "T_last_name",
  },
  {
    id: "Email",
    numeric: false,
    disablePadding: false,
    label: "T_email",
  },
  {
    id: "gender",
    numeric: false,
    disablePadding: false,
    label: "T_gender",
  },
  {
    id: "residenceCountryId",
    numeric: false,
    disablePadding: false,
    label: "T_residence_country",
  },
  {
    id: "Id",
    numeric: false,
    disablePadding: false,
    label: "T_department",
  },
  {
    id: "companyJobId",
    numeric: false,
    disablePadding: false,
    label: "T_job",
  }
];
